import { createSelector } from '@reduxjs/toolkit';

import type { IState } from '@/Module/Store/Model';
import { teacherSelectById } from '@/Module/Teacher/Store/Selector/index';

export const selectedTeacherSelector = createSelector(
  [(state: IState) => teacherSelectById(state, state.teacher?.selectedId ?? '')],
  teacher => {
    return teacher;
  },
);
